var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1060,
    height: 750,
    viewBox: "0 0 1060 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3214_23448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016.56 598.557C1016.56 682.189 948.755 750 865.115 750H43V151.435C43 67.7983 110.805 -0.00606944 194.451 -0.00606944H1016.56V598.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.513 445.207H811.131C813.1 445.207 816.822 444.897 818.598 444.505C830.617 441.907 840.628 431.234 840.628 416.699C840.628 402.161 830.617 391.461 818.598 388.86C816.822 388.472 813.1 388.158 811.131 388.158H748.513V445.207Z",
    fill: "url(#paint0_linear_3214_23448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.813 50.4757C744.071 50.4757 695.641 98.9095 695.641 158.642V270.997H848.703C852.25 270.997 856.591 271.244 859.299 271.385C893.94 273.122 919.487 290.917 919.487 321.8C919.487 346.083 902.024 366.818 870.247 371.486V372.707C905.352 375.143 932.226 394.458 932.226 424.902C932.226 457.826 902.729 478.997 863.405 478.997H695.641V699.514H854.299C914.04 699.514 962.471 651.079 962.471 591.342V50.4757H803.813Z",
    fill: "url(#paint1_linear_3214_23448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.212 329.625C833.212 315.335 823.205 305.758 811.433 303.764C810.334 303.578 807.336 303.288 805.272 303.288H748.513V355.953H805.272C807.336 355.953 810.334 355.657 811.433 355.471C823.205 353.477 833.212 343.906 833.212 329.625Z",
    fill: "url(#paint2_linear_3214_23448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.265 50.4757C145.518 50.4757 97.0908 98.9095 97.0908 158.642V425.784C127.429 440.481 158.771 450.054 190.671 450.054C228.072 450.054 248.618 427.225 248.618 396.504V271.003H341.654V396.504C341.654 445.591 311.522 484.962 208.124 484.962C145.895 484.962 97.0908 471.544 97.0908 471.544V699.514H255.744C315.485 699.514 363.918 651.079 363.918 591.342V50.4757H205.265Z",
    fill: "url(#paint3_linear_3214_23448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.54 50.4757C444.798 50.4757 396.367 98.9095 396.367 158.642V300.262C423.776 276.749 471.172 262.061 548.178 265.529C589.395 267.364 633.109 278.419 633.109 278.419V324.221C611.232 313.133 584.995 302.863 551.191 300.302C492.75 295.887 457.581 324.447 457.581 375.002C457.581 425.543 492.75 454.099 551.191 449.663C584.995 447.127 611.577 436.582 633.109 425.778V471.553C633.109 471.553 589.395 482.604 548.178 484.477C471.172 487.941 423.776 473.251 396.367 449.741V699.514H555.022C614.758 699.514 663.192 651.079 663.192 591.342V50.4757H504.54",
    fill: "url(#paint4_linear_3214_23448)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3214_23448",
    x1: 695.644,
    y1: 381.289,
    x2: 963.16,
    y2: 381.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#137F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862493,
    stopColor: "#59C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59C134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3214_23448",
    x1: 695.638,
    y1: 43.6067,
    x2: 963.161,
    y2: 43.6067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#137F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862493,
    stopColor: "#59C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59C134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3214_23448",
    x1: 695.638,
    y1: 296.419,
    x2: 963.146,
    y2: 296.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#137F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862493,
    stopColor: "#59C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59C134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3214_23448",
    x1: 96.7443,
    y1: 43.6067,
    x2: 368.399,
    y2: 43.6067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862493,
    stopColor: "#1575C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1575C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3214_23448",
    x1: 394.768,
    y1: 43.6067,
    x2: 658.602,
    y2: 43.6067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862493,
    stopColor: "#ED1443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1443"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3214_23448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 973.562,
    height: 750,
    fill: "white",
    transform: "translate(43)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.f373b5beeb8e4d9deb83bf51a6a0676a.svg";
export { ForwardRef as ReactComponent };